import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const PropertyModalWrapper = styled(Modal)`
  &.user-access-modal{
    width: min(1280px, 95vw) !important;
  }
  .ant-btn-primary{
    background-color: #0B2A1B!important;
  }
  .ant-modal-body{
    padding: 0;
  }
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
      color: #0B2A1B;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  .tab-pane-body{
    padding: 24px;
  }
  .ant-tabs-nav{
    margin: 0 24px;
  }
  .table-wrapper{
    overflow-x: auto;
    margin-bottom: 16px;
  }
  .table-status{
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  .empty-state{
    padding: 24px;
    text-align: center;
    color: #667085;
  }
  .settings-form{
    display: flex;
    flex-direction: column;
    gap: 16px;
    .ant-form-item{
      margin-bottom: 0;
    }
    .settings-suboptions{
      margin-left: 32px;
      .settings-radio-group{
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      &.disabled{
        opacity: 0.5;
      }
    }
    .settings-radio-group{
      display: flex;
      flex-direction: column;
      gap: 8px;
      .ant-radio-wrapper{
        display: flex;
        align-items: flex-start;
        width: 100%;
        line-height: 1.4;
      }
    }
  }
  .settings-actions{
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
  .action-buttons{
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  .typelabel{
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: left;
      color: #344054;
      margin-bottom : 0px !important;

  }
`;

export default WithDirection(PropertyModalWrapper);
